import { IPromotions, IBuildings } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IJunctionPostMetaResponse } from '@/shared';

const prefix = '/property-api/promotions';

/**
 * Fetches Promotions <br>
 * API Endpoint - `/property-api/promotions${qs}` <br> via {@link adminRequest.get}
 * @param {IQueryCommandOptions} [filters] - optional query string filters
 */
export const get = (filters?: IQueryCommandOptions) => {
  const qs = convertQueryCommandToQueryString({
    ...filters || {},
    ...{ select: ['$(count:buildings.id|status~not:deleted)'] },
  });
  return adminRequest.get(`${prefix}${qs}`);
};

/**
 * Fetches Promotions by ID <br>
 * API Endpoint - `/property-api/promotions/${promotionId}${qs}` <br> via {@link adminRequest.get}
 * @param {number} promotionId - id of the promotion to fetch
 */
export const getById = (promotionId: number) => {
  const qs = convertQueryCommandToQueryString({
    relations: [
      { path: 'buildings', alias: 'b' },
    ],
  });

  return adminRequest.get(`${prefix}/${promotionId}${qs}`);
};
/**
 * Creates a new Promotion <br>
 * API Endpoint - `/property-api/promotions` <br> via {@link adminRequest.post}
 * @param {IPromotions} data - promotion to insert
 */
export const insert = (data: IPromotions[]) => adminRequest.post<IPromotions[]>(`${prefix}`, data);

/**
 * Updates Single Promotion <br>
 * API Endpoint - `/property-api/promotions/${promotionId}` <br> via {@link adminRequest.put}
 * @param {number} promotionId - id of the promotion to update
 * @param {IPromotions} data - updated promotion
 */
export const update = (
  promotionId: number,
  data: IPromotions,
) => adminRequest.put(`${prefix}/${promotionId}`, data);

/**
 * Updates Properties of the specified Promotion <br>
 * API Endpoint - `/property-api/promotions/${promotionId}/properties` <br> via {@link adminRequest.post}
 * @param {number} promotionId - id of the promotion to update
 * @param {number[]} data - properties data
 */
export const updateProperties = (
  promotionId: number,
  data: number[],
) => adminRequest.post<IBuildings, IJunctionPostMetaResponse<unknown[]>>(`${prefix}/${promotionId}/properties`, data);

/**
 * Deletes Promotion <br>
 * API Endpoint - `/property-api/promotions` <br> via {@link adminRequest.delete}
 * @param {number} promotionId - id of the promotion to delete
 */
export const remove = (
  promotionId: number,
) => adminRequest.delete(`${prefix}`, [promotionId]);

export default {
  get,
  getById,
  insert,
  update,
  updateProperties,
  remove,
};
